// extracted by mini-css-extract-plugin
module.exports = {"root":"n11-meta_root__qALGl","inner":"n11-meta_inner__AuW0K"};